// JavaScript Document
//components/configuration/disdplay/Sequence.js
import React from 'react';
import Digits from './Digits';



export default function DigitSequence(props) {
  	//const classes = useStyles();
  	const {timing, sequence, scale} = props;
	const [step, setStep] = React.useState(0);
	const [isOn, setIsOn] = React.useState(true);
	const [flashing, setFlashing] = React.useState(false);

	
	React.useEffect(() => {
		setFlashing(true);
		setStep(0);
		setIsOn(true);
	}, [props]);
	
	React.useEffect(() => {
		if(flashing){
			setIsOn(false);
			setTimeout(() => {
				setFlashing(false);
				setStep(0);
				setIsOn(true);
			}, timing.period * 1000 * 2);
		} else {
			setIsOn(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [flashing]);
	
	React.useEffect(() => {
		if(flashing){
			if(isOn){
				setTimeout(() => setIsOn(false), timing.on);
			} else {
				setStep((step+1)%sequence.length);
				setTimeout(() => setIsOn(true), timing.off);
			}
		} else {
			setIsOn(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isOn]);
	const renderDigits = () => {
		if(isOn)
			return (sequence[step]);
		return '';
	}
	
	return (
		<Digits scale={scale || 2} text={renderDigits()} />
  );
}
